import React, { Component } from "react";
import { Accessor, ColorX, IconX, LocaleX, NavX } from "IZOX/STATIC";
import { HStack, XButton, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class Breadcrumb extends Component {

  static propTypes = {
    steps: PropsType.arrayOf(PropsType.shape({
      caption: PropsType.shape({
        EN: PropsType.string,
        TC: PropsType.string
      }),
      target: PropsType.string
    })),
    last:  PropsType.shape({
      EN: PropsType.string,
      TC: PropsType.string
    })
  }

  static defaultProps = {
    steps: [],
    last: null
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Breadcrumb.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  _toPage = (url) => {
    let {history} = this.props;
    NavX.Goto(history, url);
  }

  render(){
    let {steps, last} = this.props;
    return (
      <HStack fullWidth HAlign="[" pV={20}>
        {_.map(steps, (o, i) => {
          let {caption, target} = o;
          return (
            <HStack spacing={10} key={i} width={"auto"}>
              <XButton onPress={() => this._toPage(target)} padding={0}
                color={ColorX.CSS("Gray4")}>
                <HStack width={"auto"}>
                  <XText fontSize={12} noWrap>
                    {LocaleX.Parse(caption)}
                  </XText>
                </HStack>
              </XButton>
              {IconX.Get("awesome", "chevron-right", 14, ColorX.CSS("Gray4"))}
            </HStack>
          );
        })}
        <HStack width={"auto"} pL={10}>
          <XText fontSize={12} color={ColorX.CSS("Stone")} noWrap>
            {LocaleX.Parse(last)}
          </XText>
        </HStack>
      </HStack>
    );
  }

}

export default withRouter(observer(Breadcrumb));
